import { fetchWithState, getFetchedJSON } from '~/misc/fetch';



export const getSpecificIndicator = (getState, data) => {
    return fetchWithState(getState, {
        url: `/v1/search/v2/capacity/getSignals`,
        method: 'POST',
        body: {
            pickUp: data.pickUp,
            dropOff: data.dropOff,
            equipment: data.equipment.toLocaleLowerCase(),
        },
    }, false).then(getFetchedJSON);
}


// WEBPACK FOOTER //
// ./src/api/indicator.js